import axiosClient, { responseBody } from '@/api/axios-client';

export interface OwnedGem {
  id: number;
  name: string;
}

export const getGems = () => {
  return axiosClient.get<OwnedGem[]>('/api/gems').then(responseBody);
};

export const setActiveGem = (gemId: number) => {
  return axiosClient
    .put<{ activeGem: string }>(`/api/activeGem/${gemId}`)
    .then(responseBody);
};
